import moment from "moment"
import { FORMAT_DATE, SEARCH_OBJECT_MAX_SIZE } from "../../constants/moduleConsts"
import { ITimesheet } from "../models/timesheetModels"
import { findList } from "../../utils/functionUtils"
import { CODE_STATUS, LIST_STATUS } from "../../manager-request/constants/managerRequestConsts"

export const INIT_TIME_SHEETS: ITimesheet = {
    ...SEARCH_OBJECT_MAX_SIZE,
    id: "",
    donViCongTac: null,
    donViCongTacCode: "",
    donViCongTacId: "",
    donViCongTacText: "",
    phongBan: null,
    phongBanId: "",
    phongBanText: "",
    trangThai: findList(LIST_STATUS, CODE_STATUS.TAO_MOI),
    nam: Number(moment().format(FORMAT_DATE.YYYY)),
    thang: Number(moment().format(FORMAT_DATE.MM)),
    tableTimesheet: []
}

export const CODE_WEEKEND = "WKN"
export const CODE_HOLIDAY = "TrLt"

export const NUMBER_SHEET_TIMESHEET_OVERVIEW = 1
export const NUMBER_SHEET_TIMESHEET_SHIFT = 2;

export const LIST_DEFAULT_CODE_TIMEKEEPING_SCHEDULE = [ "TrLt", "Tr", "T12/24", "TrT", "T8"]

export const REF_TAB_TIMESHEET = {
    TAB_TIMESHEET: "TAB_TIMESHEET",
    TAB_OVERTIME: "TAB_OVERTIME",
    TAB_SCHEDULE: "TAB_SCHEDULE",
    TAB_TIMESHEET_OVERVIEW: "TAB_TIMESHEET_OVERVIEW",
    TAB_TIMESHEET_SYNTHETIC: "TAB_TIMESHEET_SYNTHETIC",
};

export const LIST_TAB_TIMESHEET = [
    { id: REF_TAB_TIMESHEET.TAB_TIMESHEET, nameTab: "TIMESHEET.LIST"},
    { id: REF_TAB_TIMESHEET.TAB_OVERTIME, nameTab: "TIMESHEET.LIST.OVERTIME"},
    { id: REF_TAB_TIMESHEET.TAB_SCHEDULE, nameTab: "TIMESHEET.LIST.SCHEDULE"},
];

export const LIST_TAB_TIMESHEET_OVERTIME = [
    { id: REF_TAB_TIMESHEET.TAB_TIMESHEET_OVERVIEW, nameTab: "GENERAL.TIMEKEEPING_TABLE"},
    { id: REF_TAB_TIMESHEET.TAB_TIMESHEET_SYNTHETIC, nameTab: "TIMESHEET.LIST.SYNTHETIC"}
];

export const TYPE_TIMESHEET = {
    CHAM_CONG_THEO_PHONG_BAN: 1,
    CHAM_CONG_THEO_DAY_TRUC: 2
}

export const LIST_ATTRIBUTION_OVERTIME = [
    { name: "Số giờ ngày làm việc", fieldName: "soGioLamThemNgayLamViec" },
    { name: "Số giờ ngày T7,CN", fieldName: "soGioLamThemCuoiTuan" },
    { name: "Số giờ ngày Lễ,Tết", fieldName: "soGioLamThemLeTet" },
    { name: "Số giờ ngày làm đêm", fieldName: "soGioLamThemDem" },
]